import useUserFeatureFlag from '../../feature_flag/useUserFeatureFlag';

export function useDisplayNotificationButton() {
  const [hasWebNotifications] = useUserFeatureFlag('notifications_web');
  return { hasWebNotifications };
}
